import React from 'react'
import Head from 'next/head'
import {useRouter} from 'next/router'
import {useTranslation} from '@lib/intl/useTranslations'

import useScreenLog from '@hook/useScreenLog'
import PageConfig from '@component/layouts/PageConfig/PageConfig'

import TermsNavTabs from '../components/TermsNavTabs'
import LivePolicyKorean from '@feature/common/components/terms/LivePolicy/LivePolicyKorean'
import LivePolicyEnglish from '@feature/common/components/terms/LivePolicy/LivePolicyEnglish'

const LivePolicyPage: React.FC = () => {
    const t = useTranslation()
    const {} = useScreenLog({pageName: 'term_point'})

    const language = useRouter().locale
    return (
        <PageConfig mainClassName={'bg-white dark:bg-bg_dark_background'}>
            <Head>
                <title>{t('chatRule.page.title')}</title>
            </Head>
            <div className={'layout-desktop default_page_padding '}>
                <TermsNavTabs />
                {language == 'ko' ? <LivePolicyKorean /> : <LivePolicyEnglish />}
            </div>
        </PageConfig>
    )
}

export default LivePolicyPage
